// extracted by mini-css-extract-plugin
export var infoItem = "_tu-2";
export var title = "_tu-0";
export var value = "_tu-1";